export default "__VITE_ASSET__C4Xbaq6m__"